<p>{{ 'FILTERS.' + translationKey + '.INTRO' | translate }}</p>
<filter-component name="{{ 'FILTERS.' + translationKey + '.TITLE' | translate }}">
	<ion-select placeholder="{{ 'FILTERS.' + translationKey + '.PLACEHOLDER' | translate }}" filter-content (ionChange)="filterData($any($event).detail.value)" [interfaceOptions]="selectOptions" [multiple]="multiple" replaceSelectIcon>
		<ion-select-option *ngFor="let selection of data" [value]="selection.value">
			<!-- Use translate when using values from code, and use object name when getting data from database -->
			<ng-container *ngIf="usingLocalData && useTranslation === true; else fetchedData">
				{{ 'FILTERS.' + translationKey + '.OPTIONS.' + selection.name | translate }}
			</ng-container>
			<ng-template #fetchedData>
				{{selection.name}}
			</ng-template>
		</ion-select-option>
	</ion-select>
</filter-component>

